var _defs, _path, _b, _text;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStep1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "157px",
    height: "152px",
    viewBox: "-0.5 -0.5 157 152",
    content: "<mxfile host=\"Electron\" modified=\"2020-04-28T10:37:40.272Z\" agent=\"Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_3) AppleWebKit/537.36 (KHTML, like Gecko) draw.io/12.1.0 Chrome/76.0.3809.139 Electron/6.0.7 Safari/537.36\" version=\"12.1.0\" etag=\"jQwM-kRA0MnX3eprHXFW\" type=\"device\" pages=\"3\"><diagram id=\"HQilsyjTWlzrHc4o97-6\">rZVNj5swEIZ/DVJ7SAU4kOxxSbYfh0qVUqlnBxyw1nio45Skv74z2A6QZKVWKjlgP/Nhz8wrErFNe/5keNd8hUqoKI2rc8S2UZomWcbwReTiSbJcO1IbWXk2gp38LTyMPT3JShxnjhZAWdnNYQlai9LOGDcG+rnbAdT81I7X4g7sSq7u6Q9Z2cbRdboa+Wch6yacnORPztLy4OwrOTa8gn6C2EvENgbAulV73ghF3Qt9cXEf37BeL2aEtn8TkLqAX1ydfG3+XvYSisUrdrRsxJnXoCNWdMLIVlhhRvotIKyg6Btpxa7jJYX1qAFkjW0V7hJcGrDcSsq0XSQZBRzdhOMPKcvz1Tpes2TFsnyZk80aeL22GRXAioNUagMKzHBBdsjod3WdWPLhoQjQdsLdg9xXL4wV5zc7mFzngooWgGWaC7qEgKelC/FiTpde3f2ojCQIt5mo4slrnnsx1tfU47xw4Uf2eHzswfhyZakXHdezOeY/TySqonRteEajqffvMqwOj4nH9/uhLzG1bHHgrVQX540peEuj9IksDvyIXIueckFLB85dJpnciCnPOu7OzoBNtwuuZK2dpcSWk6jINmhocXQiIqMG03I1GEMpuKr9e6h5H8CXQLB/+1svZK45Ad/onW51I1iBt+f7wYH014HUdphaVkTZFgk/WfAipgBf01aJA6UifUn8ejx7bKFzEyqlrr/TZrtYIlF8L1TBy9fawElXQbAatPg/Wk1ZeqPV+E6r2QOpBrd/kCpux6/YYJv8GbCXPw==</diagram></mxfile>",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("g", null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 49.03 26 L 106.97 26 L 133 75 L 106.97 124 L 49.03 124 L 23 75 Z",
    fill: "#f5f5f5",
    stroke: "#666666",
    strokeWidth: 10,
    strokeMiterlimit: 10,
    transform: "rotate(-152,78,75)",
    pointerEvents: "none"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(62.5,25.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible"
    },
    pointerEvents: "none",
    width: 31,
    height: 94,
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      verticalAlign: "top",
      whiteSpace: "nowrap",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "inline-block",
      textAlign: "inherit",
      textDecoration: "inherit"
    }
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      color: "rgb(51 , 51 , 51)",
      fontFamily: "&quot",
      fontSize: 80,
      textAlign: "center",
      whiteSpace: "normal"
    }
  }, _b || (_b = /*#__PURE__*/React.createElement("b", null, "I")))))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 16,
    y: 53,
    fill: "#000000",
    textAnchor: "middle",
    fontSize: "12px",
    fontFamily: "Helvetica"
  }, "[Not supported by viewer]"))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep1);
export default __webpack_public_path__ + "static/media/step-1.6b1b0371bdbe61fb049e71a6d6a3c4ec.svg";
export { ForwardRef as ReactComponent };